module.exports = __webpack_public_path__ + "img/double-arrow-gray.efdd23b4.png";